// extracted by mini-css-extract-plugin
module.exports = {"btn":"add-to-favorite_btn__o5XQs","liked":"add-to-favorite_liked__HTE43","icon":"add-to-favorite_icon__01AQg"};